export enum PortalErrorStateScheduleEnum {
  FundingFormStatesStartIndex = 1000,

  PortalCashOperationsResolverErrorStatesStartIndex,
  PortalCashOperationsAddResolverErrorStatesStartIndex,
  CashOperationsDepositAddComponentErrorStatesStartIndex,
  PortalCashOperationsWithdrawalsFormStatesStartIndex,
}
